import { Component, OnInit } from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { MyUtils } from "src/app/services/my-utils.service";
import { RecordsManager } from "../../records-manager";

@Component({
  selector: "records-page-size-select",
  templateUrl: "./page-size-select.component.html",
  styleUrls: ["./page-size-select.component.scss"],
})
export class PageSizeSelectComponent<T extends object> implements OnInit {
  sizes = [10, 15, 20];

  constructor(public recordsManager: RecordsManager<T>, public utils: MyUtils) {}

  ngOnInit(): void {
    this.sizes = this.recordsManager.tableConfig?.pageSizes || [];
  }

  onSelectionChange(event: MatSelectChange) {
    this.recordsManager.paginator.pageSize = event.value;
    this.recordsManager.paginator.firstPage();
    this.recordsManager.paginator.page.emit();
  }
}
